import styled from 'styled-components';

const Title = styled.h1`
  ${(props) => props.theme.config.typograph[props.size]};
  color: ${(props) => props.theme.config.colors[props.color]};
  font-weight: ${(props) => props.fontWeight};
`;

export { Title };
